export function littleText(text: string): string {
  const regex = /([|{}@[\]()<>\\*_~]|(#(?![A-Za-z])))/g;
  return text.replace(regex, '\\$&');
}
